import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../material/material.module';
import {UtilitiesModule} from '../utilities/utilities.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ReportModule} from '../report/report.module';
import {CerfEditComponent} from './components/cerf-edit/cerf-edit.component';
import {CerfService} from './services/cerf/cerf.service';
import {CerfFormComponent} from './components/cerf-form/cerf-form.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {CerfCommentsComponent} from './components/cerf-comments/cerf-comments.component';
import {CerfCommentComponent} from './components/cerf-comment/cerf-comment.component';
import {CerfConfirmationDialogComponent} from './components/cerf-confirmation-dialog/cerf-confirmation-dialog.component';
import {TextMaskModule} from 'angular2-text-mask';
import {CerfReportComponent} from './components/cerf-report/cerf-report.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    UtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    ReportModule,
    TextMaskModule
  ],
  declarations: [
    CerfEditComponent,
    CerfFormComponent,
    DashboardComponent,
    CerfCommentsComponent,
    CerfCommentComponent,
    CerfConfirmationDialogComponent,
    CerfReportComponent
  ],
  entryComponents: [
    CerfConfirmationDialogComponent
  ],
  exports: [],
  providers: [
    CerfService
  ]
})
export class CerfModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/cerf.module.ts